(function () {
  var drawer = document.getElementById('OsCartDrawer');
  if (!drawer) return;
  var OS = window.OS || {};
  var root = OS.root || '/';
  if (root.slice(-1) !== '/') root += '/';
  var SID = drawer.dataset.section;
  var panel = drawer.querySelector('.os-cd__panel');
  var lastFocus = null;
  var onCartPage = document.body.classList.contains('template-cart');

  function isOpen() { return drawer.classList.contains('is-open'); }
  function open() {
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { panel.focus(); }, 60);
  }
  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function render(html) {
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('[data-cd-content]');
    var cur = drawer.querySelector('[data-cd-content]');
    if (fresh && cur) cur.replaceWith(fresh);
  }
  function syncCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (window.OS && OS.setCartCount) OS.setCartCount(cart.item_count);
        return cart;
      });
  }
  function refresh() {
    return fetch(root + '?section_id=' + encodeURIComponent(SID))
      .then(function (r) { return r.text(); })
      .then(render);
  }
  function post(path, body) {
    drawer.classList.add('is-loading');
    body.sections = SID;
    body.sections_url = location.pathname;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status && res.description) { alert(res.description); return refresh(); }
        if (res && res.sections && res.sections[SID]) render(res.sections[SID]); else return refresh();
      })
      .then(syncCount)
      .catch(function () { return refresh(); })
      .finally(function () { drawer.classList.remove('is-loading'); });
  }

  document.addEventListener('click', function (e) {
    var cartLink = e.target.closest('.os-hd__cart');
    if (cartLink && !onCartPage) { e.preventDefault(); refresh().then(open); return; }
    if (!drawer.contains(e.target)) return;
    if (e.target.closest('[data-cd-close]')) { e.preventDefault(); close(); return; }
    var q = e.target.closest('[data-line][data-q]');
    if (q) { post('cart/change.js', { line: +q.dataset.line, quantity: Math.max(0, +q.dataset.q) }); return; }
    var add = e.target.closest('[data-add]');
    if (add) { add.disabled = true; post('cart/add.js', { items: [{ id: +add.dataset.add, quantity: 1 }] }); }
  });

  drawer.addEventListener('change', function (e) {
    if (e.target.matches('[data-note]')) {
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!isOpen()) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href],button:not([disabled]),textarea,input,select,summary');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  document.addEventListener('cart:open', function () { refresh().then(open); });
  document.addEventListener('cart:refresh', function () { refresh(); });
})();
